import { Skeleton } from "primereact/skeleton";
import { ThemeContext } from "../../../theme/ThemeContext";
import { useContext } from "react";

const DocStatsCard = ({
  title,
  value,
  pages,
  icon,
  bgColor = "#fff",
  loading = false, 
  onClick,
}) => {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";
  return (
    <div className="col-12 col-md-6 col-lg-4">
      <div
className={`h-100 border-0 rounded-3 shadow d-flex flex-column justify-content-center ${
  !loading ? "doc-stats-card" : ""
}`}
         onClick={loading ? undefined : onClick} 
        style={{
          backgroundColor: loading ? (isDark ? "#191919" : "#fff") : bgColor,
          minHeight: "160px",
          padding: "1rem",
          cursor: loading ? "default" : "pointer", 
        }}
      >
        {loading ? (
          <div className="d-flex align-items-center justify-content-between w-100" style={{ gap: "12px" }}>
            {/* Icon Skeleton */}
            <Skeleton shape="circle" size="50px" />
            
            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
              <Skeleton width="60%" height="24px" />
              <Skeleton width="40%" height="32px" />
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px" }}>
              <Skeleton width="60px" height="16px" />
              <Skeleton width="40px" height="24px" />
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center justify-content-between w-100 p-2 gap-3">
            <div className="d-flex align-items-center gap-3">
              <img
                src={icon}
                alt={title}
                style={{ width: 50, height: 54, objectFit: "contain" }}
              />
              <div>
                <h6 className="mb-1 text-dark">{title}</h6>
                <h2 className="fw-bold mb-0 text-dark">{value}</h2>
              </div>
            </div>

            <div className="vr" style={{ minHeight: "90px" }}></div>

            <div className="text-end">
              <h6 className="mb-1 text-dark">Total Pages</h6>
              <h4 className="fw-bold mb-0 text-dark">{pages}</h4>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocStatsCard;
